import React, { useEffect, useState } from 'react';
import { Table, Spinner, Badge, Form, InputGroup, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import client from '../api/client';
import PageHeader from '../components/PageHeader';
import { fmtMoney, fmtDate } from '../utils/format';

const Payments = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bucket, setBucket] = useState('');
  const [status, setStatus] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (bucket) params.bucket = bucket;
      if (status) params.status = status;
      const { data } = await client.get('/payments', { params });
      setItems(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const totals = items.reduce(
    (acc, p) => {
      const amt = p.amount || 0;
      if (p.status === 'cleared' || p.status === 'received') {
        if (p.bucket === 'account') acc.account += amt;
        else if (p.bucket === 'pdc') acc.pdc += amt;
        acc.received += amt;
      } else if (p.status === 'pending') {
        acc.pending += amt;
      }
      return acc;
    },
    { account: 0, pdc: 0, received: 0, pending: 0 }
  );

  return (
    <div>
      <PageHeader title="Payments" subtitle="All payments across bookings" />

      <div className="row g-3 mb-3">
        <div className="col-md-3"><div className="bg-white rounded p-3 border"><small className="text-muted">In Account (cleared)</small><h5 className="mb-0 text-success">{fmtMoney(totals.account)}</h5></div></div>
        <div className="col-md-3"><div className="bg-white rounded p-3 border"><small className="text-muted">In PDC / Cash</small><h5 className="mb-0 text-info">{fmtMoney(totals.pdc)}</h5></div></div>
        <div className="col-md-3"><div className="bg-white rounded p-3 border"><small className="text-muted">Total Received</small><h5 className="mb-0 text-primary">{fmtMoney(totals.received)}</h5></div></div>
        <div className="col-md-3"><div className="bg-white rounded p-3 border"><small className="text-muted">Pending</small><h5 className="mb-0 text-warning">{fmtMoney(totals.pending)}</h5></div></div>
      </div>

      <div className="d-flex gap-2 mb-3">
        <Form.Select style={{ maxWidth: 200 }} value={bucket} onChange={(e) => setBucket(e.target.value)}>
          <option value="">All buckets</option>
          <option value="account">Account</option>
          <option value="pdc">PDC / Cash</option>
        </Form.Select>
        <Form.Select style={{ maxWidth: 200 }} value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">All statuses</option>
          <option value="received">Received</option>
          <option value="cleared">Cleared</option>
          <option value="pending">Pending</option>
          <option value="bounced">Bounced</option>
        </Form.Select>
        <Button onClick={load}><i className="bi bi-arrow-clockwise"></i> Refresh</Button>
      </div>

      {loading ? <Spinner animation="border" /> : (
        <Table hover responsive>
          <thead>
            <tr>
              <th>Date</th><th>Booking</th><th>Customer</th><th>Mode</th>
              <th>Bucket</th><th>Amount</th><th>Status</th><th>Reference</th><th>Target/Due</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={9} className="text-center text-muted py-4">No payments</td></tr>}
            {items.map((p) => (
              <tr key={p._id}>
                <td>{fmtDate(p.receivedDate)}</td>
                <td>
                  <Link to={`/bookings/${p.booking?._id}`}>{p.booking?.bookingNo}</Link>
                  <br /><small className="text-muted">{p.booking?.project?.name}</small>
                </td>
                <td>{p.booking?.customerName}</td>
                <td className="text-uppercase">{p.mode}</td>
                <td><Badge bg={p.bucket === 'account' ? 'success' : 'info'} className="text-uppercase">{p.bucket}</Badge></td>
                <td>{fmtMoney(p.amount)}</td>
                <td><Badge bg={p.status === 'cleared' ? 'success' : p.status === 'pending' ? 'warning' : p.status === 'bounced' ? 'danger' : 'info'} className="text-uppercase">{p.status}</Badge></td>
                <td>{p.referenceNo || '-'}<br /><small className="text-muted">{p.bankName}</small></td>
                <td><small>T: {fmtDate(p.targetDate)}<br />D: {fmtDate(p.dueDate)}</small></td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default Payments;
